import { Color } from 'src/theme/color';

export const doughnutLabelsLine = {
	id: 'doughnutLabelsLine',
	afterDraw(chart: any, args: any, options: any) {
		const {
			ctx,
			chartArea: { top, bottom, left, right, width, height },
		} = chart;

		chart.data.datasets.forEach((dataset: any, i: any) => {
			chart.getDatasetMeta(i).data.forEach((datapoint: any, index: any) => {
				const { x, y } = datapoint.tooltipPosition();

				//draw line
				const halfHeight = height / 2;
				const halfWidth = width / 2;
				const length = 15;

				const radius = width / 19;
				const startX = x + (width / 18) * ((x - halfWidth) / 100);
				const startY = y + (height / 18) * ((y - halfHeight) / 100);
				const xLine = x >= halfWidth ? startX + length : startX - length;
				const yLine = y >= halfHeight ? startY + length : startY - length;
				const extraLine = x >= halfWidth ? length : -length;

				ctx.beginPath();
				ctx.moveTo(startX, startY);
				ctx.lineTo(xLine, yLine);
				ctx.lineTo(xLine + extraLine, yLine);
				ctx.strokeStyle = 'white';
				ctx.stroke();
				ctx.closePath();

				//text
				ctx.font = '14px Sora';
				const textWidth = ctx.measureText(chart.data.labels[index]).width;

				//control the position
				const plusFivePx = x >= halfWidth ? 5 : -5;
				const percentTextPosition = x >= halfWidth ? 0 : textWidth;

				ctx.textAlign = 'left';
				ctx.textBaseline = 'middle';
				ctx.fillStyle = 'white';
				ctx.fillText(chart.data.labels[index], xLine + extraLine + plusFivePx - percentTextPosition, yLine);
				ctx.font = 'bold 16px Sora';
				const percentWidth = ctx.measureText(chart.data.datasets[0].data[index]).width;

				ctx.textAlign = 'left';
				ctx.fillText(
					chart.data.datasets[0].data[index],
					xLine + extraLine + plusFivePx - percentTextPosition + 7,
					yLine + 25
				);
				ctx.fillStyle = Color.HASHUP;
				ctx.textAlign = 'left';
				ctx.fillText('%', xLine + extraLine + plusFivePx - percentTextPosition + 7 + percentWidth, yLine + 25);
			});
		});
	},
};

export const options = {
	borderAlign: 'outer',
	animation: {
		duration: 400,
	},
	layout: { padding: 30 },
	maintainAspectRatio: false,
	plugins: {
		legend: { display: false },
		tooltip: {
			enabled: false,
		},
	},
};
